import React from 'react';

import CustomModal from 'src/components/customModal/CustomModal';

export interface IBerryDeliveryAddress {
  address_name: string;
  street: string;
  street_name: string;
  city: string;
  state: string;
  zipcode: string;
  country: string;
  apartment_no: string;
  full_address: string;
  isGuestAddress: boolean;
  id: number | null;
}

interface Props {
  show: boolean;
  address: IBerryDeliveryAddress;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeliveryAddressConfirmModal: React.FC<Props> = ({ show, address, onConfirm, onCancel }) => (
  <CustomModal
    showModal={show}
    title=""
    closeModal={onCancel}
    modalDialogClasses="itemOrderModal"
    modalBodyClass="overflow-visible"
  >
    <h4 className="f-s22 font-Cls text-center fw-normal lh-22 mb-0 text-capitalize">
      Confirm delivery address
    </h4>
    <div className="w-50 mx-auto">
      <div className="justify-content-center mb-4 mt-2">
        <span className="d-block f-s14 font-Visby-cf f-w5">
          {address.street}
          {address.apartment_no ? `, ${address.apartment_no}` : ''}
        </span>
        <span className="d-block f-s14 font-Visby-cf f-w5">
          {address.city}, {address.state} {address.zipcode}
        </span>
      </div>
    </div>
    <div className="justify-content-center app_container_wrap px-1 py-2 text-center">
      <div className="text-center">
        <button type="button" className="btn-large" onClick={onConfirm}>
          Confirm &amp; Checkout
        </button>
        <button
          type="button"
          className="btn mt-3 p-0 f-w6 p-16 clr-dark-red text-center w-100 mb-5 font-Vcf"
          onClick={onCancel}
        >
          Cancel
        </button>
      </div>
    </div>
  </CustomModal>
);

export default DeliveryAddressConfirmModal;
